export const temporalReplacementElement = (query: string) => {
    const queryItems = query.split('=');
    if (queryItems.length == 2 && queryItems[0].includes('Element')) {
        queryItems[0] = queryItems[0].replace('Element', 'ElementDefinitionName');
        const result = queryItems.join('=');
        return result;
    }
    return query;
};
